import { executeRequest, Request } from '@jfs/network'
import { updateUserDeviceRequestBody } from '../data/request/requestbody'
import { APIEndPoints } from './APIEndpoints'
import { userDeviceConfig } from './config'

const responseParser = (data: any) => {
  const respData = data
  return respData
}

const updateUserDeviceReq = (tokens: any, deviceId: string, appId: string, status: number) => {
  const request: Request<{}> = {
    apiPath: APIEndPoints.updateUserDevice,
    method: 'POST',
    config: userDeviceConfig(tokens),
    body: updateUserDeviceRequestBody(deviceId, appId, status),
    headers: {
      'Content-Type': 'application/json',
      Authorization: tokens?.userAccessToken ?? '',
    },
  }
  return executeRequest(request).then((data) => {
    return responseParser(data.data)
  })
}

export { updateUserDeviceReq }
